import React, { useState, useEffect } from "react";
import { Button } from "../../button/Button";
import { useTranslation } from "react-i18next";
import "./RenameFolderModal.css";

export const RenameFolderModal = ({ folderName, onRename, onCancel }) => {
    const { t } = useTranslation();
    const [name, setName] = useState(folderName || "");

    useEffect(() => {
        setName(folderName || "");
    }, [folderName]);

    const handleSubmit = () => {
        const trimmed = name.trim();
        if (!trimmed) return;

        onRename(trimmed);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSubmit();
        }
    };

    return (
        <div className="rename-folder-modal-overlay" onClick={onCancel}>
            <div className="rename-folder-modal" onClick={(e) => e.stopPropagation()}>
                <div className="rename-folder-modal-title">
                    {t('folderMenu.renameFolder')}
                </div>
                <input
                    type="text"
                    placeholder={t('folderMenu.addFolder')}
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    onKeyDown={handleKeyDown}
                    autoFocus
                />
                <div className="rename-folder-modal-actions">
                    <Button
                        text={t('confirmationDialog.cancel')}
                        status="secondary"
                        onClick={onCancel}
                    />
                    <Button
                        text={t('confirmationDialog.confirm')}
                        type="primary"
                        onClick={handleSubmit}
                    />
                </div>
            </div>
        </div>
    );
};
